// src/EditProfile.js
import React, { useEffect, useState } from "react";
import profileImg from "../image/hifi.png";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import "../style.css";
import { getData, postData } from "../api/protectedApi";
import { toast } from "react-toastify";

const EditProfile = () => {
  const [updating, setUpdating] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    status: "",
  });

  // 🔹 Fetch profile
  const fetchProfile = async () => {
    try {
      const res = await getData("/profile");

      if (res?.data?.user_data) {
        const user = res.data.user_data;
        const paidStatus = Number(user.paid_status);

        setFormData({
          name: user.name || "",
          phone: user.phone || "",
          email: user.email || "",
          status: paidStatus === 1 ? "Active" : "Inactive",
        });
      }
    } catch (error) {
      toast.error("Failed to load profile");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchProfile();
  }, []);

  // 🔹 Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // 🔹 Update profile
  const handleUpdate = async () => {
    if (updating) return;

    setUpdating(true);

    try {
      const res = await postData("/profile_save", {
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
      });

      if (res?.success) {
        toast.success("Profile updated successfully");
        fetchProfile();
      } else {
        toast.error(res?.message || "Update failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setUpdating(false);
    }
  };


  return (
    <div
      style={{
        backgroundColor: "#0d0e13",
        minHeight: "100vh",
        color: "#fff",
        padding: "12px 0",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <DashboardNavbar />

      <section className="profile-page">
        <div className="container">
          <div className="row align-items-center gy-4">

            {/* Left Image */}
            <div className="col-lg-6 text-center">
              <img
                src={profileImg}
                alt="Profile Illustration"
                className="profile-img"
              />
            </div>

            {/* Right Form */}
            <div className="col-lg-6">
              <div className="profile-box">
                <h2 className="profile-title">Your Personal Information</h2>

                {loading ? (
                  <p className="text-white">Loading...</p>
                ) : (
                  <>
                    <div className="profile-group">
                      <label className="profile-label">Name</label>
                      <input
                        className="profile-input"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="profile-group">
                      <label className="profile-label">Phone number</label>
                      <input
                        className="profile-input"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="profile-group">
                      <label className="profile-label">Email</label>
                      <input
                        className="profile-input"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="profile-group">
                      <label className="profile-label">Status</label>
                      <input
                        className={`profile-input profile-status ${formData.status === "Active" ? "active" : "inactive"
                          }`}
                        value={formData.status}
                        readOnly
                      />
                    </div>
                    <button
                      className="profile-btn"
                      onClick={handleUpdate}
                      disabled={updating}
                      style={{
                        opacity: updating ? 0.7 : 1,
                        cursor: updating ? "not-allowed" : "pointer",
                      }}
                    >
                      {updating ? "Updating..." : "Update"}
                    </button>
                  </>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EditProfile;
